import * as React from 'react';
import { FlashMessageConsumer } from '~/FlashMessage';
export var FlashMessage = function () { return (<FlashMessageConsumer>
		{function (message) { return (<div className='bottom left ui toast-container' data-testid='flash-message'>
				<div className='floating toast-box compact transition unclickable visible' data-style={{ display: 'table !important' }}>
					<div className={"".concat(message.type, " ui toast compact visible")} style={{ opacity: 1 }}>
						<div className='content'>
							<div className='ui header'>{message.text}</div>
							<div>{message.subtext}</div>
						</div>
					</div>
				</div>
			</div>); }}
	</FlashMessageConsumer>); };
FlashMessage.displayName = 'Application.FlashMessage';
